(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateEditBookingController', CreateEditBookingController);

    CreateEditBookingController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog', 'countries', 'localization'];

    function CreateEditBookingController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog, countries, localization) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        var vm = this;
        vm.$onInit = init;
        vm.lowFiFee = 20;
        vm.musicianFee = 80;
        vm.countries = countries;
        vm.lowFiBookingFeeInfo = lowFiBookingFeeInfo;
        vm.calculateShares = calculateShares;
        vm.goToBookingPayment = goToBookingPayment;
        vm.close = close;
        vm.countryChanged = countryChanged;
        vm.confirmBookingContract = confirmBookingContract;
        vm.getFeeVoucher = getFeeVoucher;

        function init() {
            vm.loading = true;
            window.document.title = $stateParams.language == 'da' ? "Booking - Be My Concert" : "Booking - Be My Concert";
            vm.uiDateOptions = angular.copy($rootScope.uiDateConfig);
            vm.uiDateOptions.minDate = new Date();
            switch($stateParams.language){
                case 'da':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
                case 'en':
                    vm.datePlaceholder = 'DD.MM.YYYY'
                    break;
                case 'sv':
                    vm.datePlaceholder = 'DD.MM.ÅÅÅÅ'
                    break;
            }
            if($stateParams.band_booking_token) {
                vm.showBeforeBookingPage = false;
                getBookingDetails().then(function () {
                    getBandInfo(vm.booking.band_slug);
                    vm.booking.band_booking_duration = vm.booking.band_booking_duration.toString();
                    vm.booking.band_booking_time = moment(vm.booking.band_booking_time, "hh:mm:ss").toDate();
                    vm.booking.band_booking_date = moment(vm.booking.band_booking_date).toDate();
                    vm.checkout_fee = vm.booking.band_booking_currency == "sek" ? 20.00 : 15.00;
                    if(vm.booking.band_booking_status == 'pending') {
                        vm.showBookingAgreement = true;
                    }
                    vm.is_creator = vm.booking.user_is_booker;
                    vm.loading = false;
                });
            } else {
                vm.showBeforeBookingPage = true;
                vm.booking = {
                    band_booking_duration: '60',
                    band_booking_currency: 'dkk',
                    band_booking_country: 'DK',
                    band_booking_band_percentage: 80,
                    band_booking_lowfi_percentage: 20,
                    discount_amount: 0
                };
                getBandInfo();
                getCurrencies();
                vm.checkout_fee = 20.00;
                vm.loading = false;
            }
        }

        function getFeeVoucher() {
            var callback = function (response) {
                if (response.data.fee_voucher_error) {
                    if(vm.booking.fee_voucher_id) {
                        vm.booking.fee_voucher_id = null;
                    }
                    vm.voucher_error = response.data.fee_voucher_error;
                } else {
                    vm.voucher_error = null;
                    vm.fee_voucher_amount = response.data.amount;
                    vm.fee_voucher_discount = response.data.discount;
                    vm.booking.fee_voucher_id = response.data.id;
                    feeVoucherCalculate();
                    vm.voucher_added = true;
                }

            };
            if (vm.booking.fee_voucher_id) {
                return $http.post('/app/api/fee_voucher/get_by_id/', { id: vm.booking.fee_voucher_id }).then(callback);
            } else {
                return $http.post('/app/api/fee_voucher/get/', { code: vm.code, type: 'bookings' }).then(callback);
            }
        }

        function feeVoucherCalculate() {
            vm.booking.discount = vm.fee_voucher_discount;
            vm.booking.band_booking_lowfi_percentage = vm.fee_voucher_amount;
            vm.booking.band_booking_band_percentage = 100 - vm.booking.band_booking_lowfi_percentage - vm.fee_voucher_discount;
            calculateShares();
        }

        function calculateShares() {
            vm.booking.discount_amount = vm.booking.discount ? (vm.booking.discount * vm.booking.band_booking_fee)/100 : 0;
            vm.booking.lowfi_fee = vm.booking.band_booking_fee ? Math.round(vm.booking.band_booking_fee * vm.booking.band_booking_lowfi_percentage)/100 : 0;
            vm.booking.musician_fee = vm.booking.band_booking_fee ? Math.round(vm.booking.band_booking_fee * vm.booking.band_booking_band_percentage)/100 : 0;
        }

        vm.isBookingDateValid = function () {
            return vm.booking ? moment(vm.booking.band_booking_date).isValid() : false;
        }

        vm.isBookingTimeValid = function () {
            return vm.booking  ? moment(vm.booking.band_booking_time).isValid() : false;
        }

        function countryChanged() {
            vm.booking.band_booking_currency = localization.currencyFromCountry(vm.booking.band_booking_country);
            vm.checkout_fee = 20.00;
        }

        function getBookingDetails() {
            return $http.get('api/booking/band/' + $stateParams.band_booking_token)
                .then(function (response) {
                    vm.booking = response.data;
                    calculateShares();

                    if (vm.booking.band_booking_paid_timestamp != null) {
                        alert("This booking has already been paid.");
                        close();
                    }
                });
        }

        $scope.$on("$locationChangeStart", function(event) {
            if (vm.BookingForm.$dirty) {
                event.preventDefault();
                dialog.prompt('unsaved-changes-prompt', function (response) {
                    if (response.confirm) {
                        return $state.go('member');
                    }
                }, true);
            }
        });

        function goToBookingPayment() {
            vm.BookingForm.$setSubmitted();
            if (!formIsValid()) {
                return false;
            }

            return $http.post('api/book/band/', vm.booking)
                .then(function(response){
                    return $state.go('edit_booking',{band_booking_token: response.data}, {location: 'replace'}).then(function() {

                        /* $http.post('api/checkout/create/booking/', {band_booking_token: response.data})
                            .then(function(response){
                                var checkout_id = parseInt(response.data);
                                return $state.go('checkout', { checkout_id: checkout_id});
                            }); */

                    });
                });
        }

        function confirmBookingContract() {
            vm.confirmed = true;
            if(vm.is_creator) {
                $http.post('api/checkout/create/booking/', {band_booking_token: $stateParams.band_booking_token})
                    .then(function(response){
                        var checkout_id = parseInt(response.data);
                        return $state.go('checkout', { checkout_id: checkout_id});
                    });
            }

        }

        function bookingTermsInfo() {
            dialog.info('booking-terms-info');
        }

        function lowFiBookingFeeInfo() {
            dialog.info('low-fi-booking-fee-info');
        }

        function close() {
            if (vm.BookingForm.$dirty) {
                dialog.prompt('unsaved-changes-prompt', function (response) {
                    if (response.confirm) {
                        goBack();
                    }
                    if (response.alternative) {
                        save().then(function() {
                            goBack();
                        });
                    }
                }, true);
            } else {
                goBack();
            }
        }

        function goBack() {
            if ($stateParams.backToStateName) {
                return $state.go($stateParams.backToStateName, $stateParams.backToStateParams)
            } else {
                return $state.go('frontpage');
            }
        }

        function formIsValid() {
            return vm.BookingForm.$valid && vm.booking.band.band_admin_has_payment_info;
        }

        function getCurrencies() {
            return $http.get('api/currencies/')
                .then(function (response) {
                    vm.currencies = response.data;
                });
        }

        function getBandInfo(band_slug) {
            $http.get('api/bands/' + (band_slug ? band_slug : $stateParams.band_slug) + '/')
                .then(function (response) {
                    vm.booking.band = response.data;
                    calculateShares();
                });
        }

        $scope.$on('$destroy', function () {
            if($stateParams.band_booking_token && vm.is_creator && !vm.confirmed) {
                $http.post('api//booking/delete', {band_booking_token: $stateParams.band_booking_token})
                    .then(function(response){

                    });
            }
        });
    }
})();
